import React, { useMemo } from "react";
import ReactDOM from "react-dom";
import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import "./company-dashboard-initiative-drawer-view-cleared-milestone.scss";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import MUITable, {
  TableHeader,
} from "../../../../../../common/components/mui-table/mui-table";
import DeleteConfirmationPopup from "../../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import CompanyDashboardInitiativeDrawerAddMilestones from "../company-dashboard-initiative-drawer-add-milestones/company-dashboard-initiative-drawer-add-milestones";

const headers: TableHeader[] = [
  { key: "milestone", label: "Title" },
  { key: "department", label: "Department", filterable: true },
  { key: "date", label: "Date" },
  { key: "status", label: "Status" },
];
const CompanyDashboardInitiativeDrawerViewClearedMilestones: any = (
  props: any,
) => {
  const {
    isOpenViewPopup,
    onCancel,
    clearedMilestonesData,
    handleDeleteMilestone,
    setDeletePopupOpen,
    isDeletePopupOpen,
    deletePopupId,
    isOpenAddPopup,
    setIsOpenAddPopup,
    editData,
    setEditData,
    addPopupTitle,
    setAddPopupTitle,
    milestonesData,
    setMilestonesData,
    employeesList,
    setLoading,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    initiativeId,
    fetchInitiativeById,
    fetchInitiatives,
    keyResultId,
    objectiveId,
    initiativeAPIData,
    fetchAllMilestones,
    departmentsList,
    fetchMilestoneDepartments,
    fetchUpcomingMilestones,
  } = props;

  const handleCloseDialog = () => {
    if (onCancel && typeof onCancel === "function") {
      onCancel();
    }
  };

  // Extract unique departments from cleared milestones data
  const milestoneDepartments = useMemo(() => {
    if (!clearedMilestonesData || clearedMilestonesData.length === 0) {
      return [];
    }

    const uniqueDepartments = Array.from(
      new Map(
        clearedMilestonesData
          .filter(
            (item: any) =>
              item?.data?.departmentId && item?.data?.departmentName,
          )
          .map((item: any) => [
            item.data.departmentId,
            {
              key: item.data.departmentId,
              value: item.data.departmentName,
            },
          ]),
      ).values(),
    ) as Array<{ key: string | number; value: string }>;

    return uniqueDepartments;
  }, [clearedMilestonesData]);

  const handleCloseAddPopup = () => {
    if (setIsOpenAddPopup && setEditData && setAddPopupTitle) {
      setIsOpenAddPopup(false);
      setEditData(null);
      setAddPopupTitle("");
    }
  };
  return (
    <>
      <Dialog
        open={isOpenViewPopup}
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start", // move dialog to top
          },
          "& .MuiDialog-paper": {
            mt: 2, // spacing from top
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`company-dashboard-initiative-drawer-view-cleared-milestone`}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          onCancel();
        }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="company-dashboard-initiative-drawer-cleared-milestone">
              <div className="company-dashboard-initiative-drawer-cleared-milestone-header">
                <div>Milestone History</div>
                <div className="company-dashboard-initiative-drawer-disposition-header-actions"></div>
              </div>
              <OverlayScrollbarsComponent
                options={{
                  scrollbars: {
                    theme: "os-theme-dark",
                    autoHide: "scroll",
                    autoHideDelay: 400,
                  },
                }}
                style={{ maxHeight: "600px", overflowY: "auto" }}
              >
                <div className="company-dashboard-initiative-drawer-cleared-milestone-content">
                  <MUITable
                    columnNames={headers}
                    rowsData={clearedMilestonesData}
                    showChatColumn={false}
                    showActionsColumnWithOptions={false}
                    onFilterChange={() => {}}
                    departmentsList={milestoneDepartments}
                    noRecordsTitle="No Milestones available to display."
                    noRecordsMessage="Please reload the page, or add a new Milestone."
                    isFromMilestone={true}
                  />
                </div>
              </OverlayScrollbarsComponent>
              <div className="company-dashboard-initiative-drawer-cleared-milestone-close">
                <div className="company-dashboard-initiative-drawer-cleared-milestone-close-text">
                  <button
                    className="company-dashboard-initiative-drawer-cleared-milestone-close-text-button"
                    onClick={handleCloseDialog}
                    type="button"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {isDeletePopupOpen &&
        ReactDOM.createPortal(
          <DeleteConfirmationPopup
            isOpen={true}
            onClose={() => setDeletePopupOpen?.(false)}
            handleDelete={() => {
              if (handleDeleteMilestone) {
                handleDeleteMilestone();
              }
            }}
            deleteId={deletePopupId}
          />,
          document.body,
        )}
      {isOpenAddPopup &&
        ReactDOM.createPortal(
          <CompanyDashboardInitiativeDrawerAddMilestones
            isOpenAddPopup={isOpenAddPopup}
            onCancel={handleCloseAddPopup}
            addPopupTitle={addPopupTitle}
            editData={editData}
            setEditData={setEditData}
            milestonesData={milestonesData}
            setMilestonesData={setMilestonesData}
            employeesList={employeesList}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            initiativeId={initiativeId}
            fetchInitiativeById={fetchInitiativeById}
            fetchInitiatives={fetchInitiatives}
            keyResultId={keyResultId}
            objectiveId={objectiveId}
            initiativeAPIData={initiativeAPIData}
            fetchAllMilestones={fetchAllMilestones}
            departmentsList={departmentsList}
            fetchMilestoneDepartments={fetchMilestoneDepartments}
            fetchUpcomingMilestones={fetchUpcomingMilestones}
          />,
          document.body,
        )}
    </>
  );
};

export default CompanyDashboardInitiativeDrawerViewClearedMilestones;
